import { ScheduleEventData } from '@mantine/schedule';
import type { PayloadType } from '../../../../types';
import {
  AnnouncementHoverCard,
  BdayHoverCard,
  FestivalHoverCard,
  ShowHoverCard,
} from './components';

type EventHoverCardPropsType = {
  event: ScheduleEventData<PayloadType>;
};

export const EventHoverCard: React.FC<EventHoverCardPropsType> = ({
  event,
}) => {
  switch (event.payload?.type) {
    case 'BDAY':
      return event.payload.birthday ? (
        <BdayHoverCard birthday={event.payload.birthday} />
      ) : null;
    case 'ANNOUNCEMENT':
      return event.payload.announcement ? (
        <AnnouncementHoverCard announcement={event.payload.announcement} />
      ) : null;
    case 'FESTIVAL':
      return event.payload.festival ? (
        <FestivalHoverCard festival={event.payload.festival} />
      ) : null;
    case 'SHOW':
      return event.payload.show ? (
        <ShowHoverCard show={event.payload.show} />
      ) : null;
    default:
      return null;
  }
};
